import acAuth from "./acAuth";
import requiredUpdatesRedirects from "./requiredUpdatesRedirects";
import cpAuth from "./cpAuth";
import { emailDomains } from "./emailDomains";
import constantsErrorMessageByCode from "./errorMessages";
import legacyAuth from "./legacyAuth";
import constantsProgressBar from "./progressBarFriendlyStepName";
import constantsRedline from "./redline";
import unificationPaths from "./unification";
import acp from "./acp";
import partnersMetadata from "./partnersMetadata";
import { publicRoutes } from "./publicRoutes";
import { pageNames } from "./pageNames";
import cookies from "./cookies";
import customDispatchEvents from "./customDispatchEvents";
import { signinWithPasswordOnly } from "./signinWithPasswordOnly";

const constants = {
	redline: constantsRedline,
	legacyAuth: legacyAuth,
	progressBar: constantsProgressBar,
	errorDetails: constantsErrorMessageByCode,
	acAuth: acAuth,
	acp: acp,
	acpAuth: acAuth,
	cpAuth: cpAuth,
	emailDomains: emailDomains,
	conflictingEmailRedirects: requiredUpdatesRedirects,
	unificationPaths: unificationPaths,
	partnersMetadata: partnersMetadata,
	publicRoutes: publicRoutes,
	pageNames: pageNames,
	cookies: cookies,
	customDispatchEvents: customDispatchEvents,
	signinWithPasswordOnly: signinWithPasswordOnly,
};

export default constants;
